<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import ExcelImport from "@/components/ExcelImport.vue";
import ExcelExport from "@/components/ExcelExport.vue";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelImport,
    ExcelExport,
    DataTable,
  },
  data() {
    return {
      title: "Products",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Products",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsProductsDataServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      unitmodal_id: "",
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      nameError: "",
      unitError: "",
      categoryError: "",
      productError: "",
      sellingPriceError: "",
      branchError: "",
      UnitProductunitError: "",
      UnitqtyError: "",
      UnitsellingPriceError: "",

      // Value from user input for adding product

      filterProducts: {
        branch_id: 0,
        product: "",
        category: "",
        efrisstatus: "",
        page: 1,
        per_page: 50,
      },

      // edit product
      editdata: {
        name: "",
        code: "",
        minimum: 10,
        selling_price: "",
        reserve_price: "",
        vat: 0,
        id: "",
      },
      // delete product
      deletedata: {
        name: "",
        id: "",
      },

      excelTemplateFields: {
        PRODUCT_CATEGORY: "PRODUCT_CATEGORY",
        EFRIS_CATEGORY_CODE: "EFRIS_CATEGORY_CODE",
        PRODUCT_NAME: "PRODUCT_NAME",
        UNIT_NAME: "UNIT_NAME",
        UNIT_SYMBOL: "UNIT_SYMBOL",
        QUANTITY: "QUANTITY",
        BUYING_PRICE: "BUYING_PRICE",
        SELLING_PRICE: "SELLING_PRICE",
        RETAIL_RESERVE_PRICE: "RETAIL_RESERVE_PRICE",
        MINIMUM_QUANTITY: "MINIMUM_QUANTITY",
        PRODUCT_CODE: "PRODUCT_CODE",
        VAT_CHARGED: "VAT_CHARGED",
        IS_PRODUCT: "IS_PRODUCT",
        BATCH_NUMBER: "BATCH_NUMBER",
        EXPIRY_DATE: "EXPIRY_DATE",
        IS_BASE: "IS_BASE",
        BASE_QUANTITY: "BASE_QUANTITY",
        WHOLESALE_PRICE: "WHOLESALE_PRICE",
        WHOLESALE_RESERVE_PRICE: "WHOLESALE_RESERVE_PRICE",
      },

      excelRequiredHeaders: [
        "PRODUCT_CATEGORY",
        "EFRIS_CATEGORY_CODE",
        "PRODUCT_NAME",
        "UNIT_NAME",
        "UNIT_SYMBOL",
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", [
      "SaveStatus",
      "ProductsData",
      "ProductsDataPagination",
      "Categories",
      "FilterStatus",
      "ProductsDataPaginated",
    ]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    sampleImportData() {
      if (this.ProductsData && this.ProductsData.length > 0) {
        // Take first 2 products as samples, or all if less than 2
        return this.ProductsData.slice(0, 2).map((product) => ({
          PRODUCT_CATEGORY:
            product.category && product.category.name
              ? product.category.name
              : "",
          EFRIS_CATEGORY_CODE: product.efrisCategory,
          PRODUCT_NAME: product.name,
          UNIT_NAME:
            product.baseunit && product.baseunit.name
              ? product.baseunit.name
              : "",
          UNIT_SYMBOL:
            product.baseunit && product.baseunit.code
              ? product.baseunit.code
              : "",
          QUANTITY: product.instock,
          BUYING_PRICE:
            product.stock && product.stock.buying_price
              ? product.stock.buying_price
              : "",
          SELLING_PRICE: product.selling,
          RETAIL_RESERVE_PRICE: product.reserve,
          MINIMUM_QUANTITY: product.minimum,
          PRODUCT_CODE: product.code,
          VAT_CHARGED: product.vat,
          IS_PRODUCT: product.type,
          BATCH_NUMBER: "",
          EXPIRY_DATE: "",
          IS_BASE: 1,
          BASE_QUANTITY: 1,
          WHOLESALE_PRICE: product.wholesale_unitprice,
          WHOLESALE_RESERVE_PRICE: product.wholesale_reserveprice,
        }));
      }
      return [];
    },

    rows() {
      return this.IsProductsDataServerPaginated
        ? this.ProductsDataPagination.total
        : this.ProductsData
        ? this.ProductsData.length
        : 0;
    },

    productColumns() {
      const cols = [
        {
          key: "index",
          label: "S/N",
        },
        {
          key: "name",
          label: "NAME",
        },
        {
          key: "product_category",
          label: "Category",
        },
        {
          key: "qty_field",
          label: "IN STOCK",
        },
        {
          key: "minimum",
          label: "MINIMUM QTY",
        },
        {
          key: "tax",
          label: "TAX CATEGORY",
        },
        {
          key: "type_field",
          label: "TYPE",
        },
        {
          key: "efrisstatus",
          label: "STATUS",
        },
        {
          key: "actions",
          label: "ACTIONS",
        },
      ];

      return cols;
    },

    perPage: {
      get() {
        if (this.IsProductsDataServerPaginated) {
          return (
            (this.ProductsDataPagination &&
              this.ProductsDataPagination.per_page) ||
            this.filterProducts.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsProductsDataServerPaginated) {
          this.filterProducts.per_page = value;
          this.filterProducts.page = 1;
          this.FetchProducts(this.filterProducts);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.ProductsDataPaginated && this.ProductsDataPagination
          ? this.ProductsDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ProductsDataPaginated) {
          this.filterProducts.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          this.closeModal(this.modal_id);
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchProducts: "products/fetchProductsData",
      EditProduct: "products/editProduct",
      DeleteProduct: "products/deleteProduct",
      FetchCategories: "products/fetchPCategories",
      FetchBranches: "general/fetchBranches",
      SendProducts: "products/TransferProducts",
      FetchSegments: "products/fetchSegments",
      FetchFamilies: "products/fetchFamilies",
      FetchClasses: "products/fetchClasses",
      FetchEfrisCategories: "products/fetchCategories",
      AddProductUnit: "products/addProductUnit",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      EfrisPdtImport: "products/EfrisPdtImport",
      EfrisTaxImport: "products/updateTaxCategory",
      SyncProducts: "products/SyncProducts",
    }),

    handlePageChange(newPage) {
      if (this.IsProductsDataServerPaginated) {
        this.filterProducts.page = newPage;
        this.FetchProducts(this.filterProducts);
      }
    },

    // Handle Excel import success
    handleExcelImportSuccess(result) {
      Swal.fire(
        "Success!",
        result.message || "Products imported successfully!",
        "success",
      );
      this.FetchProducts(this.filterProducts);
      this.closeModal("import-products-modal");
    },

    // Handle Excel import error
    handleExcelImportError(error) {
      Swal.fire("Error!", error, "error");
    },

    // Custom validation for Excel import
    validateProductsData(data) {
      const errors = [];

      data.forEach((row, index) => {
        const rowNum = index + 2;

        // Check required fields
        if (
          !row.PRODUCT_CATEGORY ||
          String(row.PRODUCT_CATEGORY).trim() === ""
        ) {
          errors.push(`Row ${rowNum}: Product Category is required`);
        }
        if (
          !row.EFRIS_CATEGORY_CODE ||
          String(row.EFRIS_CATEGORY_CODE).trim() === ""
        ) {
          errors.push(`Row ${rowNum}: Efris Category Code is required`);
        }
        if (!row.PRODUCT_NAME || String(row.PRODUCT_NAME).trim() === "") {
          errors.push(`Row ${rowNum}: Product Name is required`);
        }
        if (!row.UNIT_NAME || String(row.UNIT_NAME).trim() === "") {
          errors.push(`Row ${rowNum}: Unit Name is required`);
        }
        if (!row.UNIT_SYMBOL || String(row.UNIT_SYMBOL).trim() === "") {
          errors.push(`Row ${rowNum}: Unit Symbol is required`);
        }

        // Validate numeric fields
        const qty = Number(row.QUANTITY);
        if (
          row.QUANTITY === null ||
          row.QUANTITY === undefined ||
          row.QUANTITY === "" ||
          Number.isNaN(qty) ||
          qty < 0
        ) {
          errors.push(
            `Row ${rowNum}: Quantity must be a valid non-negative number`,
          );
        }

        const buyingPrice = Number(row.BUYING_PRICE);
        if (
          row.BUYING_PRICE === null ||
          row.BUYING_PRICE === undefined ||
          row.BUYING_PRICE === "" ||
          Number.isNaN(buyingPrice) ||
          buyingPrice < 0
        ) {
          errors.push(
            `Row ${rowNum}: Buying Price must be a valid non-negative number`,
          );
        }

        const sellingPrice = Number(row.SELLING_PRICE);
        if (
          row.SELLING_PRICE === null ||
          row.SELLING_PRICE === undefined ||
          row.SELLING_PRICE === "" ||
          Number.isNaN(sellingPrice) ||
          sellingPrice < 0
        ) {
          errors.push(
            `Row ${rowNum}: Selling Price must be a valid non-negative number`,
          );
        }
      });

      return errors;
    },

    // Export event handlers
    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting the data. Please try again.",
        confirmButtonText: "OK",
      });
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    resetEdit() {
      this.editdata.name = "";
      this.editdata.code = "";
      this.editdata.minimum = 10;
      this.editdata.selling_price = "";
      this.editdata.reserve_price = "";
      this.editdata.vat = 0;
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.categoryError = "";
      this.unitError = "";
      this.productError = "";
      this.sellingPriceError = "";
      this.UnitProductunitError = "";
      this.UnitqtyError = "";
      this.UnitsellingPriceError = "";
    },

    resetUnitError() {
      this.UnitProductunitError = "";
      this.UnitqtyError = "";
      this.UnitsellingPriceError = "";
    },

    showEditModal(data) {
      this.editdata.name = data.item.name;
      this.editdata.reserve_price = data.item.reserve;
      this.editdata.selling_price = data.item.selling;
      this.editdata.vat = data.item.vat;
      this.editdata.code = data.item.code;
      this.editdata.minimum = data.item.minimum;
      this.editdata.id = data.item.id;
    },

    editProduct(modalId) {
      this.modal_id = modalId;
      this.EditProduct(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.item.id;
    },

    deleteProduct(modalId) {
      this.modal_id = modalId;
      this.DeleteProduct(this.deletedata);
    },

    redirect(value) {
      this.$router.push(`/stock/movement/${btoa(value)}`);
    },
    //== close modal
    closeModal(modalId) {
      this.resetError();
      this.resetEdit();
      this.resetDelete();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    //== close modal
    closeUnitModal(modalId) {
      this.resetUnitError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    FilterProducts() {
      this.filterProducts.page = 1;
      this.FetchProducts(this.filterProducts);
    },

    // import efris pdts
    ImportEfrisPdts(modalId) {
      this.EfrisPdtImport();
      this.closeModal(modalId);
    },

    // import efris pdts
    ImportEfrisTax(modalId) {
      this.EfrisTaxImport();
      this.closeModal(modalId);
    },

    // Fetch Segment
    FetchSeg() {
      if (this.Segments == "") {
        this.FetchSegments();
      }
    },

    // Fetch Families
    FetchFamily() {
      this.FetchFamilies(this.data.segment);
    },

    // Fetch Classes
    FetchClass() {
      this.FetchClasses(this.data.family);
    },

    // Synchronize pending products
    SyncPdts(modal) {
      this.SyncProducts();
      this.closeModal(modal);
    },

    // Fetch Categories
    FetchCat() {
      this.FetchEfrisCategories(this.data.class);
    },
  },

  created() {
    this.FetchProducts(this.filterProducts);
    this.FetchCategories();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row py-2">
              <div class="col-md-3">
                <b-btn-group>
                  <b-button v-b-modal.efris-products-modal variant="warning"
                    ><i class="fa fa-plus"></i> Efris Import
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                  <b-button v-b-modal.efris-tax-modal variant="success"
                    ><i class="fa fa-plus"></i> Tax Category
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                </b-btn-group>
              </div>
              <div class="col-md-2" align="right">
                <ExcelExport
                  endpoint="products/export"
                  filename="products.xlsx"
                  :payload="filterProducts"
                  button-text="Export Excel"
                  button-variant="info"
                  icon-class="fas fa-download"
                  @export-error="handleExportError"
                />
              </div>
              <div class="col-md-3" align="right">
                <b-button v-b-modal.synch-products-modal variant="info"
                  ><i class="fa fa-check"></i> Synchronize Products</b-button
                >
              </div>
              <div class="col-md-4" align="right">
                <b-btn-group>
                  <b-button
                    v-if="MyUserPerm.add_products == 1"
                    v-b-modal.import-products-modal
                    variant="info"
                    ><i class="fa fa-plus"></i> Import Products</b-button
                  >
                </b-btn-group>
              </div>
            </div>
            <div class="row mt-4 mb-4">
              <div class="col-sm-12 col-md-3 d-flex align-items-end">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>              
              <!-- Search -->
              <div class="col-sm-12 col-md-4 form-group">
                <label>SEARCH BY CATEGORY</label>
                <model-list-select
                  :list="
                    Categories
                      ? [{ id: '', catName: 'All Categories' }, ...Categories]
                      : []
                  "
                  v-model="filterProducts.category"
                  option-value="id"
                  option-text="catName"
                  placeholder="Select Category"
                  @input="FilterProducts()"
                >
                </model-list-select>
              </div>
              <div class="col-sm-12 col-md-5">
                Search Product
                <div class="input-group">
                  <input
                    v-model="filterProducts.product"
                    type="text"
                    class="form-control"
                    placeholder="Search by product name or code..."
                    @keyup.enter="FilterProducts()"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="FilterProducts()"
                    >
                      <b-spinner
                        v-if="FilterStatus"
                        variant="light"
                        small
                        label="Spinning"
                      ></b-spinner>
                      <span>Search</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-9"></div>
              <div class="form-group col-md-3 mt-3">
                <label>FILTER BY EFRIS STATUS</label>
                <select v-model="filterProducts.efrisstatus" class="form-control" @change="FilterProducts()">
                  <option value="">Select Status</option>
                  <option value="1">Synchronised</option>
                  <option value="2">Unsynchronised</option>
                </select>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="productColumns"
                :rows="ProductsData || []"
                :total-rows="rows"
                :pagination="ProductsDataPagination"
                :server-pagination="IsProductsDataServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>

                <template #cell(name)="{ row }">
                  {{ row.name }}
                </template>

                <template #cell(product_category)="{ row }">
                  {{ row.product_category }}
                </template>

                <template #cell(qty_field)="{ row }">
                  {{ row.instock }}
                  {{ row.baseunit ? row.baseunit.name : "" }}
                </template>

                <template #cell(minimum)="{ row }">
                  {{ row.minimum }}
                </template>

                <template #cell(tax)="{ row }">
                  {{ row.tax }}
                </template>

                <template #cell(type_field)="{ row }">
                  <span v-if="row.type == 1">Product</span>
                  <span v-else>Service</span>
                </template>

                <template #cell(efrisstatus)="{ row }">
                  <span
                    class="text-success"
                    v-if="row.efrisstatus == 'Synchronized'"
                    >{{ row.efrisstatus }}</span
                  >
                  <span
                    class="text-warning"
                    v-if="row.efrisstatus == 'Unsynchronized'"
                    >{{ row.efrisstatus }}</span
                  >
                </template>

                <template #cell(actions)="{ row }">
                  <b-button-group>
                    <b-button
                      v-if="MyUserPerm.edit_products == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-product-modal
                      @click="showEditModal({ item: row })"
                      ><i class="fa fa-edit"></i> Edit
                    </b-button>
                    <b-button
                      size="sm"
                      variant="success"
                      @click="redirect(row.id)"
                      ><i class="fa fa-retweet"></i> Movements
                    </b-button>
                    <b-button
                      v-if="MyUserPerm.delete_products == 1"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-product-modal
                      @click="showDeleteModal({ item: row })"
                      ><i class="fa fa-trash"></i> Delete
                    </b-button>
                  </b-button-group>
                </template>

                <template #empty>
                  <div class="text-center p-3">No products found.</div>
                </template>

                <template #loading>
                  <div class="text-center p-3 text-warning">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </DataTable>
            </div>

            <!-- Pagination controls -->
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="products-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- edit modal starts -->
    <b-modal id="edit-product-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Product {{ editdata.name }}</template>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Product Name<span class="text-danger">*</span></label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                @input="resetError()"
                v-model="editdata.name"
              />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Minimum Quantity (<small>Warn Quantity</small>)</label>
            <div class="input-group">
              <input
                type="number"
                placeholder="Warn Quantity"
                class="form-control"
                v-model="editdata.minimum"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Product Code</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Product Code"
                class="form-control"
                v-model="editdata.code"
              />
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Selling Price <span class="text-danger">*</span></label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Product Unit Selling Price"
                class="form-control"
                v-model="editdata.selling_price"
              />
            </div>
            <div class="text-danger" v-if="sellingPriceError">
              <em>{{ sellingPriceError }}</em>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Reserve Price</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Reserve Price"
                class="form-control"
                v-model="editdata.reserve_price"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editProduct('edit-product-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-product-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete Product {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this Product? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteProduct('delete-product-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!--PRODUCT EXCEL UPLOAD MODAL-->
    <b-modal
      id="import-products-modal"
      ref="modal"
      hide-footer
      title="Import Products from Excel"
      @hidden="file = null"
    >
      <template #modal-title> Import Products from Excel </template>
      <template>
        <ExcelImport
          :template-fields="excelTemplateFields"
          :sample-data="sampleImportData"
          template-filename="products_import_template.xlsx"
          upload-label="Select Excel file with products data:"
          import-url="import_products"
          :required-headers="excelRequiredHeaders"
          :custom-validation="validateProductsData"
          @import-success="handleExcelImportSuccess"
          @import-error="handleExcelImportError"
          @close-modal="closeModal('import-products-modal')"
        />
      </template>
    </b-modal>
    <!-- PRODUCT EXCEL UPLOAD END -->

    <!--SYNC PDTS  MODAL-->
    <b-modal
      id="synch-products-modal"
      ref="modal"
      hide-footer
      title="Synchronize products to Efris"
    >
      <div class="mb-2">
        <h5>
          You are synchnizing pending products to Efris, click synchronize to
          proceed
        </h5>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="closeModal('synch-products-modal')"
          type="button"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          type="button"
          @click="SyncPdts('synch-products-modal')"
        >
          Synchronize
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            role="status"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- SYNC PDTS MODAL END -->

    <!-- IMPORT EFRIS PDTS -->
    <b-modal
      id="efris-products-modal"
      ref="modal"
      hide-footer
      title="Import efris products"
    >
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="closeModal('efris-products-modal')"
          type="button"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          type="button"
          @click="ImportEfrisPdts('efris-products-modal')"
        >
          Import
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            role="status"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- IMPORT EFRIS PDTS -->

    <!-- IMPORT EFRIS PDTS TAX-->
    <b-modal
      id="efris-tax-modal"
      ref="modal"
      hide-footer
      title="Update Products Tax Category Code"
    >
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="closeModal('efris-tax-modal')"
          type="button"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          type="button"
          @click="ImportEfrisTax('efris-tax-modal')"
        >
          Update
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            role="status"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- IMPORT EFRIS PDTS TAX-->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
